export const FOODIMETRIC_HOST_URL = "https://foodimetric-backend.onrender.com"